module.exports = __webpack_public_path__ + "img/number05.37f88c71.svg";